const FilterModel = function () {
    return {
        applied: false,
        list: {},
        chosen: {}, // filtros aplicados
        searcher: {
            ref: null, // referencia tipo useRef del input
        },
        filter: () => {}, // reescribir esta funcion segun necesidad.
        onChangeSearcher: function (value) {
            value.trim() ? (this.chosen.searcher = value.trim()) : delete this.chosen.searcher;
            this.filter();
        },
        clear: function () {
            if (Object.keys(this.chosen).length === 0) return;
            this.chosen = {};
            if (this.searcher.ref) {
                this.searcher.ref.value = "";
            }
            this.filter();
        },
    };
};
export default FilterModel;
